import React, { useEffect, useState, useCallback } from 'react';
import { View, Text, ScrollView, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigation, useRoute } from '@react-navigation/native';
import { fontFamily } from '../../helpers/fontFamily';
import { fetchArchivedInventoryReports } from '../../actions/inventoryReportActions';
import Pagination from '../inventoryReports/pagination';
import InventoryReportTable from '../inventoryReports/inventoryReportTable';
import DeleteConfirmationModal from '../inventoryReports/deleteConfirmationModal';
import { showMessage } from "react-native-flash-message";
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  exportInventoryReport, restoreInventoryReport,
  showInventoryReport, deleteInventoryReport
} from '../../actions/inventoryReportActions';

const ArchivedReceivingReports = () => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const route = useRoute();
  const mode = route.params?.mode || '';
  const archivedInventoryReports = useSelector(state => state.inventoryReports.archivedReports);
  const pagy = useSelector(state => state.inventoryReports.archivedPagy);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(null);

  useEffect(() => {
    dispatch(fetchArchivedInventoryReports(currentPage, mode));
  }, [dispatch, currentPage, mode]);

  const exportReport = (id) => {
    dispatch(exportInventoryReport(id, mode))
      .then((message) => {
        showMessage({
          message: message || "Export email sent successfully!",
          type: "success",
          backgroundColor: '#056EAA',
          duration: 5000
        });
      })
      .catch(() => {
        showMessage({
          message: "Failed to send export email.",
          type: "danger",
        });
      });
  };

  const showReport = async (report) => {
    try {
      await AsyncStorage.setItem('current_report_mode', mode);
      await AsyncStorage.setItem('current_report', JSON.stringify(report));
      navigation.navigate('ViewInventoryReport', { id: report.id, view: 'show', from: 'archived', mode: mode });
    } catch (error) {
      console.error('Error storing mode:', error);
    }
  };

  const confirmDelete = (id) => {
    setSelectedReportId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirmed = () => {
    if (selectedReportId) {
      dispatch(deleteInventoryReport(selectedReportId))
        .then((message) => {
          showMessage({
            message: message || "Report deleted successfully!",
            type: "success",
          });
          setTimeout(() => {
            dispatch(fetchArchivedInventoryReports(currentPage, mode));
          }, 1000);
        })
        .catch(() => {
          showMessage({
            message: "Failed to delete report.",
            type: "danger",
          });
        });
      setShowDeleteModal(false);
      setSelectedReportId(null);
    }
  };

  const restoreReport = (id) => {
    dispatch(restoreInventoryReport(id))
    .then((message) => {
      showMessage({
        message: message || "Export email sent successfully!",
        type: "success",
        backgroundColor: '#056EAA',
        duration: 5000
      });
      dispatch(fetchArchivedInventoryReports(currentPage, mode));
    })
    .catch(() => {
      showMessage({
        message: "Failed to restore report.",
        type: "danger",
      });
    });
  };

  const renderTabButton = (label) => (
    <LinearGradient
      colors={['rgba(0, 0, 0, 0.6)', 'rgba(255, 255, 255, 0.15)']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={{
        width: 'fit-content',
        borderBottomLeftRadius: '0px',
        borderBottomEndRadius: '0px',
        borderTopRightRadius: '5px',
        borderTopLeftRadius: '5px'
      }}
    >
      <TouchableOpacity
        style={{
          borderRadius: 5,
          backgroundColor: 'transparent',
        }}
      >
        <Text
          style={{
            color: '#ffffff',
            fontFamily: fontFamily.font300,
            fontSize: 14,
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
        >
          {label}
        </Text>
      </TouchableOpacity>
    </LinearGradient>
  );

  return (
    <LinearGradient
      colors={[
        '#0A1118',
        '#111C29',
        '#253C57',
        '#4E6988',
        '#547193',
        '#4E6988',
        '#253C57',
        '#111B27'
      ]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      locations={[0.1, 0.19, 0.3, 0.43, 0.48, 0.53, 0.7, 0.85]}
      style={{flex: 1}}
    >
      <DeleteConfirmationModal
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirmed}
      />
      <ScrollView contentContainerStyle={{ flexGrow: 1 }} showsVerticalScrollIndicator={false}>
        <TouchableOpacity
          style={{
            borderWidth: 1,
            borderColor: '#ffffff',
            borderRadius: 15,
            alignItems: 'center',
            justifyContent: 'center',
            width: 68,
            height: 26,
            paddingHorizontal: 14,
            paddingVertical: 3,
            alignSelf: 'flex-start',
            marginTop: 20,
            marginLeft: 20
          }}
          onPress={() => navigation.navigate('InventoryReport')}
        >
          <Text style={{ color: '#ffffff', fontFamily: fontFamily.font300, fontSize: 16 }}>back</Text>
        </TouchableOpacity>
        <View style={{
          minHeight: 'fit-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%'
        }}>
          <View style={{
            padding: '20px',
            paddingBottom: '0px',
            width: '100%',
            maxWidth: 800,
            margin: 'auto',
            marginBottom: '1px'
          }}>
            <View>
              <View style={{ flexDirection: 'row', marginLeft: '-5px' }}>
                {renderTabButton( mode === 'receive' ? 'Archived Receiving Records' : 'Archived Recounting Records')}
              </View>
            </View>
          </View>
          <LinearGradient
            colors={['rgba(0, 0, 0, 0.6)', 'rgba(255, 255, 255, 0.15)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={{
              padding: 15,
              borderTopLeftRadius: 18,
              borderTopRightRadius: 18,
              marginTop: -3,
              width: '100%',
              maxWidth: 800,
              alignSelf: 'center',
              zIndex: 1,
            }}
          >
          </LinearGradient>
          <View style={{
            flexGrow: 1,
            width: '100%',
            maxWidth: 800,
            alignSelf: 'center',
            paddingHorizontal: 10,
          }}>
            {archivedInventoryReports.length > 0 ? (
              archivedInventoryReports.map(report => (
                <InventoryReportTable
                  key={report.id}
                  report={report}
                  onExport={exportReport}
                  onView={showReport}
                  onDelete={confirmDelete}
                  onRestore={restoreReport}
                />
              ))
            ) : (
              <View style={{
                textAlign: 'center',
                padding: '20px',
                fontSize: '16px',
                color: 'rgb(175, 175, 175)',
                fontFamily: 'Poppins_300Light',
              }}>
                <Text style={{ textAlign: 'center', marginTop: 20, marginBottom: 20, color: '#aaa', fontFamily: fontFamily.font300, fontSize: 16 }}>
                  No archived inventory reports available.
                </Text>
              </View>
            )}
          </View>

          <LinearGradient
            colors={['rgba(0, 0, 0, 0.2)', 'rgba(255, 255, 255, 0.15)']}
            start={{ x: 1, y: 0 }}
            end={{ x: 0, y: 0 }}
            style={{
              padding: 15,
              borderBottomLeftRadius: 18,
              borderBottomRightRadius: 18,
              width: '100%',
              maxWidth: 800,
              alignSelf: 'center',
            }}
          >
          </LinearGradient>
        </View>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagy={pagy}
        />
      </ScrollView>
    </LinearGradient>
  );
};

export default ArchivedReceivingReports;
